import { usePersistActiveEvent } from "./hooks/usePersistActiveEvent";
import { usePersistCalendarHash } from "./hooks/usePersistCalendarHash";

export const PlannerStatePersistance = () => {
  usePersistActiveEvent();
  usePersistCalendarHash();

  return null;
};
